<template>
   <v-container fluid class="px-10" style="height: 100vh">
      <v-row no-gutters class="d-flex">
         <v-col cols="12">
            <v-card>
               <v-toolbar dense :color="this.$globalstore.secondary_titleclass">
                  <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp">
                     Edit Group: {{ edit_cca_name }} [{{ edit_cca_termyeartext }}]
                  </v-toolbar-title>
                  <v-toolbar-title v-else>
                     {{ edit_cca_name }}
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn
                     v-show="saveBtnVisible"
                     color="indigo"
                     class="white ma-2"
                     outlined
                     @click="SaveGroup"
                  >
                     Save
                  </v-btn>
                  <v-btn color="indigo" class="white" outlined @click="goBack()">
                     Back
                  </v-btn>
               </v-toolbar>
               <v-sheet outlined>
                  <v-tabs
                     @change="onTabChange"
                     height="40"
                     v-model="editgrouptab"
                     :slider-color="$globalstore.tab_slidercolor"
                     :show-arrows="!$vuetify.breakpoint.mdAndUp"
                  >
                     <v-tab href="#group">Group</v-tab>
                     <v-tab href="#event">Events</v-tab>
                     <v-tab href="#participants">Participants</v-tab>
                     <v-tab href="#waitlist">Wait List</v-tab>
                     <v-tab
                        href="#consent"
                        v-show="$globalstore.UserHasCap(CapConstant.VIEW_CONSENT_ACTIVITY)"
                        >Consent Activity
                     </v-tab>
                     <!-- <v-tab href="#email">Email</v-tab> -->
                  </v-tabs>
                  <v-tabs-items v-model="editgrouptab">
                     <v-tab-item :key="1" value="group">
                        <v-form ref="groupform" v-model="groupform_valid">
                           <v-row no-gutters class="pa-0 mt-2 d-flex">
                              <v-col cols="10" md="4">
                                 <v-text-field
                                    label="Group Name"
                                    class="ml-3 mt-1 mb-0"
                                    v-model="edit_cca_name"
                                    required
                                    :rules="rules_cca_name"
                                    :counter="NameMaxLength"
                                    :maxlength="NameMaxLength"
                                 >
                                 </v-text-field>
                                 <v-text-field
                                    label="Group Description"
                                    class="ml-3 my-0"
                                    v-model="edit_cca_description"
                                    required
                                    :rules="rules_cca_description"
                                    type="text"
                                    :counter="DescriptionMaxLength"
                                    :maxlength="DescriptionMaxLength"
                                 >
                                 </v-text-field>
                              </v-col>
                              <v-col cols="8" md="2" class="px-2">
                                 <v-select
                                    v-model="edit_cca_status"
                                    class="mt-1"
                                    label="Status"
                                    :items="$globalstore.status_select"
                                    item-text="text"
                                    item-value="id"
                                    return-object
                                    :rules="[(v) => !!v || 'Status is required']"
                                    required
                                 ></v-select>
                                 <v-select
                                    class="mt-0"
                                    label="Gender"
                                    :items="$globalstore.gender_select"
                                    item-text="text"
                                    item-value="id"
                                    return-object
                                    v-model="edit_gender_constraint"
                                    required
                                 ></v-select>
                              </v-col>
                              <v-col cols="6" md="2" class="px-2">
                                 <datepicker-dialog
                                    labelname="Publish Date"
                                    :indate.sync="edit_publish_date"
                                    @return-date="onPublishDateChange"
                                 >
                                 </datepicker-dialog>
                                 <label class="caption mr-1" for="publishtime">Publish Time </label>
                                 <vue-timepicker
                                    close-on-complete
                                    name="publishtime"
                                    :minute-interval="$globalstore.minute_interval"
                                    v-model="edit_publishtime"
                                    drop-direction="down"
                                    manual-input
                                    auto-scroll
                                 ></vue-timepicker>
                              </v-col>
                              <v-col cols="6" md="2" class="px-2">
                                 <datepicker-dialog
                                    labelname="Closing Date"
                                    :indate.sync="edit_closing_date"
                                    @return-date="onClosingDateChange"
                                 >
                                 </datepicker-dialog>
                                 <label class="caption mr-1" for="closingtime">Closing Time</label>
                                 <vue-timepicker
                                    close-on-complete
                                    name="closingtime"
                                    :minute-interval="$globalstore.minute_interval"
                                    v-model="edit_closingtime"
                                    drop-direction="down"
                                    manual-input
                                    auto-scroll
                                 ></vue-timepicker>
                              </v-col>
                              <v-col cols="12" md="2">
                                 <v-checkbox
                                    label="Consent Required"
                                    class="ml-4"
                                    v-model="edit_consent_required"
                                 ></v-checkbox>
                                 <v-select
                                    class="ml-5 my-0"
                                    label="Limit Participant"
                                    :items="limitselect"
                                    item-value="id"
                                    item-text="text"
                                    return-object
                                    v-model="edit_limit_participant"
                                    required
                                 ></v-select>
                              </v-col>
                           </v-row>
                           <v-row no-gutters class="pa-0 d-flex">
                              <v-col cols="12" md="6">
                                 <year-select :years.sync="edit_year_constraint"> </year-select>
                              </v-col>
                              <v-col cols="4" md="2" class="pl-2">
                                 <v-card flat outlined>
                                    <v-card-text>
                                       <v-text-field
                                          class="pt-2"
                                          label="Minimum Participant"
                                          v-model="edit_min_participant"
                                          :rules="rules_min_participant"
                                       ></v-text-field>
                                    </v-card-text>
                                 </v-card>
                              </v-col>
                              <v-col cols="4" md="2" class="pl-2">
                                 <v-card flat outlined>
                                    <v-card-text>
                                       <v-text-field
                                          class="pt-2"
                                          label="Maximum Participant"
                                          v-model="edit_max_participant"
                                          :rules="rules_max_participant"
                                       ></v-text-field>
                                    </v-card-text>
                                 </v-card>
                              </v-col>
                              <v-col cols="4" md="2" class="pl-2">
                                 <v-card flat outlined>
                                    <v-card-text>
                                       <v-text-field
                                          class="pt-2"
                                          label="CCA Fee"
                                          v-model="edit_cca_fee"
                                          @blur="checkConsentField"
                                          :rules="rules_cca_fee"
                                       ></v-text-field>
                                    </v-card-text>
                                 </v-card>
                              </v-col>
                           </v-row>
                           <v-card outlined>
                              <v-row no-gutters>
                                 <v-col cols="4" md="">
                                    <v-select
                                       class="ml-2"
                                       label="CCA Schedule"
                                       :items="edit_scheduledata"
                                       item-text="schedule_name"
                                       item-value="id"
                                       return-object
                                       v-model="edit_schedule"
                                       readonly
                                    >
                                    </v-select>
                                 </v-col>
                                 <v-col cols="4" md="2" class="px-2">
                                    <v-text-field
                                       disabled
                                       v-if="edit_schedule"
                                       label="Start Date"
                                       readonly
                                       v-model="edit_schedule.schedule_startdate"
                                    ></v-text-field>
                                 </v-col>
                                 <v-col cols="4" md="2" class="px-2">
                                    <v-text-field
                                       disabled
                                       v-if="edit_schedule"
                                       label="End Date"
                                       readonly
                                       v-model="edit_schedule.schedule_enddate"
                                    ></v-text-field>
                                 </v-col>
                                 <v-col cols="4" md="4" class="px-2">
                                    <v-select
                                       class="mt-0"
                                       label="Category"
                                       :items="categorylist"
                                       item-text="category_name"
                                       item-value="id"
                                       return-object
                                       v-model="edit_ccacategory"
                                       required
                                    >
                                    </v-select>
                                 </v-col>
                              </v-row>
                           </v-card>
                           <v-row no-gutters class="d-flex pa-0">
                              <!-- left bottom -->
                              <v-col cols="12" md="8" class="px-1">
                                 <v-row no-gutters class="pa-0 ma-0">
                                    <v-col md="2">
                                       <div class="ml-3 mt-3 text-start">
                                          <b>Event Master</b>
                                       </div>
                                    </v-col>
                                    <v-col md="10">
                                       <div class="my-0">
                                          <v-btn
                                             x-small
                                             class="primary mx-1 my-2"
                                             @click="AddEventData"
                                          >
                                             <v-icon>mdi-plus</v-icon>
                                             Add
                                          </v-btn>
                                       </div>
                                    </v-col>
                                 </v-row>

                                 <!-- Event Master table -->
                                 <v-row no-gutters>
                                    <v-col md="12" class="px-1">
                                       <v-card height="200px" class="overflow-y-auto">
                                          <v-data-table
                                             dense
                                             :headers="eventdata_headers"
                                             hide-default-footer
                                             :items="edit_eventdata"
                                             @click:row="eventdata_rowClick"
                                             item-key="unique_id"
                                             sort-by="unique_id"
                                             single-select
                                          >
                                             <!-- eslint-disable-next-line -->
                                             <template #item.actions="{ item }">
                                                <v-icon small @click="editEventData(item)"
                                                   >mdi-pencil</v-icon
                                                >
                                                <v-icon
                                                   small
                                                   @click="removeEventData(item)"
                                                   class="ml-2"
                                                   >mdi-delete</v-icon
                                                >
                                             </template>
                                          </v-data-table>
                                       </v-card>
                                    </v-col>
                                 </v-row>
                              </v-col>
                              <!-- Right bottom -->
                              <v-col cols="12" md="4" class="px-1">
                                 <!-- admin button row -->
                                 <v-row no-gutters class="pa-0 d-flex">
                                    <v-col md="4">
                                       <div class="ml-3 mt-3 text-start">
                                          <b>Administrators</b>
                                       </div>
                                    </v-col>
                                    <v-col md="8">
                                       <div class="my-0">
                                          <v-btn
                                             x-small
                                             class="primary mx-1 my-2"
                                             @click.native="adminlistdlg = true"
                                             ><v-icon small>mdi-plus</v-icon>
                                             Add
                                          </v-btn>
                                       </div>
                                    </v-col>
                                 </v-row>
                                 <!-- admin table  -->
                                 <v-row no-gutters class="full-height">
                                    <v-col>
                                       <v-card class="overflow-y-auto" height="200px">
                                          <v-data-table
                                             dense
                                             :headers="admindata_headers"
                                             hide-default-footer
                                             :items="edit_admindata"
                                             @click:row="rowClickAdmin"
                                             item-key="id"
                                             single-select
                                          >
                                             <!-- eslint-disable-next-line -->
                                             <template #item.actions="{ item }">
                                                <v-icon
                                                   small
                                                   @click="removeAdmin(item)"
                                                   class="ml-2"
                                                >
                                                   mdi-delete
                                                </v-icon>
                                             </template>
                                          </v-data-table>
                                       </v-card>
                                    </v-col>
                                 </v-row>
                              </v-col>
                           </v-row>
                        </v-form>
                     </v-tab-item>
                     <!-- Events Listing Tab -->
                     <v-tab-item :key="2" value="event">
                        <edit-group-tab-event
                           ref="tabevent"
                           :cca_id="edit_group_id"
                           :eventlist.sync="eventlistdata"
                           @save-eventlist="saveEventListData"
                        ></edit-group-tab-event>
                     </v-tab-item>
                     <v-tab-item :key="3" value="participants">
                        <edit-group-tab-participant
                           ref="tabparticipant"
                           :max_participant="edit_max_participant"
                           :cca_id="edit_group_id"
                           :consent="edit_consent_required"
                           :gender="edit_gender_constraint"
                           :year="edit_year_constraint"
                           :participants="participantdata"
                           :ccafee="getCCAFee"
                           :closingdate="edit_closing_date"
                           @save-participantlist="saveParticipantData"
                           @update-waitlist="reloadWaitList"
                        >
                        </edit-group-tab-participant>
                     </v-tab-item>
                     <v-tab-item :key="4" value="waitlist">
                        <edit-group-tab-wait-list
                           ref="tabwaitlist"
                           :max_participant="edit_max_participant"
                           :cca_id="edit_group_id"
                           :consent="edit_consent_required"
                           :gender="edit_gender_constraint"
                           :year="edit_year_constraint"
                           :ptcpdata="participantdata"
                           :waitlist_data="waitlistdata"
                           :ccafee="getCCAFee"
                           @save-waitlist="saveWaitListData"
                           @update-participant="reloadParticipantList"
                        ></edit-group-tab-wait-list>
                     </v-tab-item>
                     <v-tab-item :key="5" value="consent">
                        <edit-group-tab-consent :cca_id="edit_group_id"></edit-group-tab-consent>
                     </v-tab-item>
                     <!-- <v-tab-item :key="6" value="email">
                        <edit-group-tab-email
                           :cca_id="edit_group_id"
                           :participants="participantdata"
                        ></edit-group-tab-email>
                     </v-tab-item> -->
                  </v-tabs-items>
               </v-sheet>
            </v-card>
         </v-col>
      </v-row>
      <confirm-dialog ref="confirm"></confirm-dialog>
      <group-admin-list
         ref="adminlist"
         :admindata="edit_admindata"
         :dialogvisible.sync="adminlistdlg"
         :multiselect="multiple_adminselect"
         @cancel-selection="adminlistdlg = false"
         @save-selection="onAdminSaveSelection"
      />
      <event-day ref="eventform" @input="onEventFormClose"></event-day>
      <!-- student list dialog -->
   </v-container>
</template>

<script>
   import {GroupConst, DESCRIPTION_MAXLENGTH, NAME_MAXLENGTH} from "@/common/constant.js";
   import CapConstant from "@/common/capconstant.js";
   import DatepickerDialog from "@/components/DatepickerDialog.vue";
   import ConfirmDlg from "@/components/ConfirmDlg.vue";
   import GroupAdminList from "@/components/GroupAdminList.vue";
   import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
   import YearSelect from "@/components/YearSelect.vue";
   import EventDay from "@/components/EventDay.vue";
   import EditGroupTabWaitList from "@/components/EditGroupTabWaitList.vue";
   import EditGroupTabEvent from "@/components/EditGroupTabEvent.vue";
   import EditGroupTabParticipant from "@/components/EditGroupTabParticipant.vue";
   import EditGroupTabConsent from "@/components/EditGroupTabConsent.vue";
   import EditGroupTabEmail from "@/components/EditGroupTabEmail.vue";

   export default {
      inject: ["ShowMessage"],

      components: {
         "confirm-dialog": ConfirmDlg,
         DatepickerDialog,
         GroupAdminList,
         VueTimepicker,
         YearSelect,
         EventDay,
         EditGroupTabEvent,
         EditGroupTabParticipant,
         EditGroupTabWaitList,
         EditGroupTabConsent,
         EditGroupTabEmail,
      },
      data() {
         return {
            DescriptionMaxLength: DESCRIPTION_MAXLENGTH,
            NameMaxLength: NAME_MAXLENGTH,
            CapConstant: Object.freeze(CapConstant),
            editgrouptab: "group",
            limitselect: GroupConst.limitselect,
            eventdata_headers: [
               {
                  text: "Day",
                  align: "start",
                  value: "daytext",
                  width: "20%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Start",
                  value: "start",
                  width: "15%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "End",
                  value: "end",
                  width: "15%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Location",
                  value: "location_name",
                  width: "40%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "",
                  value: "actions",
                  class: this.$globalstore.table_headerclass,
                  width: "10%",
                  sortable: false,
               },
            ],
            admindata_headers: [
               {
                  text: "Name",
                  align: "start",
                  value: "username",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Role",
                  value: "userroles",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "",
                  value: "actions",
                  class: this.$globalstore.table_headerclass,
                  width: "5%",
                  sortable: false,
               },
            ],
            groupform_valid: true,
            edit_scheduledata: [],
            schedule_id: "",
            edit_schedule: null,
            edit_ccacategory: null,
            categorylist: [],
            edit_group_id: "",
            edit_cca_status: null,
            edit_cca_name: "",
            edit_cca_description: "",
            edit_cca_year: "",
            edit_cca_term: "",
            edit_cca_termyeartext: "",
            edit_gender_constraint: null,
            edit_year_constraint: [],
            edit_max_participant: 0,
            edit_min_participant: 1,
            edit_consent_required: false,

            edit_eventdata: [],
            eventdata_item: null,
            multiple_adminselect: true,
            edit_admindata: [],
            edit_publish_date: "",
            edit_publishtime: "",
            edit_closing_date: "",
            edit_closingtime: "",
            edit_cca_fee: "0.00",
            edit_limit_participant: null,

            rules_cca_name: [(v) => !!v || "Name is required"],
            rules_cca_description: [(v) => !!v || "Description is required"],
            rules_max_participant: [
               (v) => !!/^[0-9]+$/.test(v) || "Max participants must be numeric.",
            ],
            rules_min_participant: [
               (v) => !!/^[0-9]+$/.test(v) || "Min participants must be numeric.",
            ],
            rules_cca_fee: [
               (v) => !!/^\d+(\.\d{2})$/.test(v) || "CCA fee must have 2 numeric decimal places.",
            ],

            locationdata: [],
            eventlistdata: [],

            participantdata: [],
            adminlistdlg: false,
            saveBtnVisible: true,
            waitlistdata: [],
         };
      },

      computed: {
         getCCAFee() {
            return parseFloat(this.edit_cca_fee);
         },
      },

      methods: {
         onTabChange(tab) {
            this.saveBtnVisible = tab === "group";
         },

         goBack() {
            this.$router.push({name: "ManageGroup"});
         },

         checkConsentField() {
            if (parseFloat(this.edit_cca_fee) > 0.0) {
               if (!this.edit_consent_required) {
                  this.edit_consent_required = true;
               }
            }
         },

         SaveGroup() {
            if (this.$refs.groupform.validate()) {
               let d1 = new Date(this.edit_publish_date);
               let d2 = new Date(this.edit_closing_date);

               if (d1 >= d2) {
                  this.ShowMessage({
                     title: "Error",
                     message: "Publish date has to be less than closing date",
                     color: "red",
                  });
                  return;
               }

               if (!this.edit_publishtime || !this.edit_closingtime) {
                  this.ShowMessage({
                     title: "Error",
                     message: "Publish time and closing time is required.",
                     color: "red",
                  });
                  return;
               }

               if (
                  !Number.isInteger(parseInt(this.edit_max_participant)) ||
                  !Number.isInteger(parseInt(this.edit_min_participant))
               ) {
                  this.ShowMessage({
                     title: "Error",
                     message: "Minimum and maximum participants must be numeric.",
                     color: "red",
                  });
                  return;
               }
               if (
                  parseInt(this.edit_max_participant) < 0 ||
                  parseInt(this.edit_min_participant) < 0
               ) {
                  this.ShowMessage({
                     title: "Error",
                     message: "Minimum and maximum participants must be positive.",
                     color: "red",
                  });
                  return;
               }

               if (parseInt(this.edit_min_participant) == 0) {
                  this.ShowMessage({
                     title: "Error",
                     message: "Minimum participant must be greater than 0.",
                     color: "red",
                  });
                  return;
               }

               if (!this.edit_ccacategory) {
                  this.ShowMessage({
                     title: "Error",
                     message: "Please select a category for this activity.",
                     color: "red",
                  });
                  return;
               }

               // let cca_fee = Number(Number.parseFloat(this.edit_cca_fee).toFixed(2));
               let cca_fee = this.$globalstore.roundCurrency(this.edit_cca_fee);

               if (cca_fee === NaN) {
                  this.ShowMessage({
                     title: "Error",
                     message: "CCA fee must be numeric.",
                     color: "red",
                  });
                  return;
               }

               if (cca_fee > 0) {
                  this.edit_consent_required = true;
               }

               if (cca_fee > 0 && !this.edit_ccacategory.category_trancode) {
                  this.ShowMessage({
                     title: "Error",
                     message:
                        "Selected CCA Category " +
                        this.edit_ccacategory.category_name +
                        " is not configured for payment.",
                     color: "red",
                  });
                  return;
               } else {
                  this.doSaveGroup();
               }
            } else {
               this.ShowMessage({
                  title: "Error",
                  message: "Please complete the form.",
                  color: "red",
               });
               return;
            }
         },

         async doSaveGroup() {
            await this.$http({
               url: "/cca/updategroup.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_id: this.edit_group_id,
                  cca_name: this.edit_cca_name,
                  cca_description: this.edit_cca_description,
                  cca_status: this.edit_cca_status.id,
                  cca_gender: this.edit_gender_constraint.id,
                  cca_publishdate: this.edit_publish_date,
                  cca_publishtime: this.edit_publishtime,
                  cca_closingdate: this.edit_closing_date,
                  cca_closingtime: this.edit_closingtime,
                  cca_year_array: this.edit_year_constraint,
                  cca_min: this.edit_min_participant,
                  cca_max: this.edit_max_participant,
                  cca_limit_participant: this.edit_limit_participant.id,
                  cca_fee: this.edit_cca_fee,
                  cca_consent: this.edit_consent_required ? 1 : 0,
                  category_id: this.edit_ccacategory.id,
                  category_trancode: this.edit_ccacategory.category_trancode,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.goBack();
                  }
               }
            });
         },

         onPublishDateChange(savedate) {
            this.edit_publish_date = savedate;
         },

         onClosingDateChange(savedate) {
            this.edit_closing_date = savedate;
         },

         async getGroupByID() {
            await this.$http({
               url: "/cca/getgroup_byid.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  group_id: this.edit_group_id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (!response.data.error) {
                     let groupdata = response.data.groupdata;

                     // save id so it can be resolved after scheduledata
                     // has been loaded.
                     this.schedule_id = groupdata.cca.schedule_id;

                     // this.edit_schedule = this.edit_scheduledata.find(
                     //    (x) => x.id == groupdata.cca.schedule_id
                     // );
                     this.edit_cca_name = groupdata.cca.cca_name;
                     this.edit_cca_description = groupdata.cca.cca_description;
                     this.edit_cca_year = groupdata.cca.cca_year;
                     this.edit_cca_term = groupdata.cca.cca_term;
                     this.edit_cca_termyeartext = groupdata.cca.termyeartext;
                     this.edit_cca_status = this.$globalstore.status_select.find(
                        (item) => item.id === groupdata.cca.cca_status,
                     );

                     this.edit_gender_constraint = this.$globalstore.gender_select.find(
                        (item) => item.id === groupdata.cca.gender_constraint,
                     );
                     // edit_year_constraint needs string
                     if (groupdata.cca.year_constraint === 1) {
                        this.edit_year_constraint = groupdata.years.map(String);
                     } else {
                        this.edit_year_constraint = [];
                     }
                     this.edit_publish_date = groupdata.cca.publish_date;
                     this.edit_publishtime = groupdata.cca.publish_time;
                     this.edit_closing_date = groupdata.cca.closing_date;
                     this.edit_closingtime = groupdata.cca.closing_time;
                     this.edit_min_participant = groupdata.cca.min_participant;
                     this.edit_max_participant = groupdata.cca.max_participant;
                     this.edit_consent_required =
                        groupdata.cca.consent_required == 1 ? true : false;

                     this.edit_limit_participant = this.limitselect.find(
                        (item) => item.id === groupdata.cca.limit_participant,
                     );

                     this.edit_cca_fee = groupdata.cca.cca_fee;
                     this.edit_ccacategory = this.categorylist.find(
                        (item) => item.id == groupdata.cca.cca_category_id,
                     );

                     if (!this.edit_ccacategory) {
                        this.edit_cca_fee = "0.00";
                        this.ShowMessage({
                           title: "Warning",
                           message: "CCA category not found. Fee is set to none.",
                           color: "orange",
                        });
                     }
                     this.edit_admindata = groupdata.admins;
                     this.edit_eventdata = groupdata.eventmaster;
                     this.eventlistdata = groupdata.events;
                     this.participantdata = groupdata.participants;
                     this.waitlistdata = groupdata.waitlist;
                  } else {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  }
               }
            });
         },

         eventdata_rowClick(item, row) {
            row.select(!row.isSelected);
         },

         async AddEventData() {
            await this.$refs.eventform.open().then((reply) => {});
         },

         async editEventData(item) {
            await this.$refs.eventform.edit(item);
         },

         async onEventFormClose(payload) {
            let event = payload.event;
            let mode = payload.mode;
            let previd = payload.previd;

            if (mode === "add") {
               let index = this.edit_eventdata.findIndex((x) => x.unique_id === event.unique_id);
               if (index === -1) {
                  await this.doAddEventData(event);
                  this.edit_eventdata.push(event);
               } else {
                  this.ShowMessage({
                     title: "Error",
                     message: "Duplicate event day and time.",
                     color: "red",
                  });
               }
            } else if (mode === "edit") {
               if (previd == event.unique_id) {
                  // only update location id
                  await this.doUpdateEvent(event);
                  let index = this.edit_eventdata.findIndex((x) => x.unique_id == previd);
                  this.$set(this.edit_eventdata, index, event);
               } else {
                  // find out if edited data will conflict with
                  // existing data.
                  let index = this.edit_eventdata.findIndex((x) => x.unique_id == event.unique_id);

                  if (index != -1) {
                     this.ShowMessage({
                        title: "Error",
                        message: "Duplicate event day and time",
                        color: "red",
                     });
                  } else {
                     // Edited data has no confict. Now need to remove previd
                     // and insert new row
                     //let index = this.edit_eventdata.findIndex((x) => x.unique_id === previd);

                     this.doReplaceEventData(previd, event);

                     this.reloadEventMaster();
                     if (this.$refs.tabevent) {
                        this.$refs.tabevent.reloadEventList();
                     }
                  }
               }
            }
         },

         async doAddEventData(event) {
            let response = await this.$http({
               url: "/cca/addeventmaster.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  ccaid: this.edit_group_id,
                  scheduleid: this.edit_schedule.id,
                  cca_description: this.edit_cca_description,
                  eventdata: [event],
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.reloadEventMaster();
                     if (this.$refs.tabevent) {
                        this.$refs.tabevent.reloadEventList();
                     }
                  }
               }
            });
         },

         async removeEventData(event) {
            await this.$refs.confirm
               .open(
                  "Warning",
                  "Are you sure you want to remove the master event on " +
                     event.daytext +
                     "? This will remove future events for that day.",
                  {color: "orange"},
               )
               .then((reply) => {
                  if (reply) {
                     this.doRemoveEventData(event);
                     if (this.$refs.tabevent) {
                        this.$refs.tabevent.reloadEventList();
                     }
                  } else {
                     return;
                  }
               });
         },

         async doRemoveEventData(event) {
            let response = await this.$http({
               url: "/cca/removeeventmaster.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_id: this.edit_group_id,
                  event: event,
                  token: this.$globalstore.user.usertoken,
                  userid: this.$globalstore.user.userid,
               },
               method: "POST",
            }).then((response) => {
               console.log(response);
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.reloadEventMaster();
                     if (this.$refs.tabevent) {
                        this.$refs.tabevent.reloadEventList();
                     }
                  }
               }
            });
         },

         async doUpdateEvent(event) {
            // This only updates the event location id.
            // dow, start, end are key components.
            await this.$http({
               url: "/cca/updateevent.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_id: this.edit_group_id,
                  event: event,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.reloadEventMaster();
                     if (this.$refs.tabevent) {
                        this.$refs.tabevent.reloadEventList();
                     }
                  }
               }
            });
         },

         async doReplaceEventData(previd, event) {
            let response = await this.$http({
               url: "/cca/replaceeventmaster.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_id: this.edit_group_id,
                  schedule_id: this.edit_schedule.id,
                  previd: previd,
                  event: event,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.reloadEventMaster();
                     if (this.$refs.tabevent) {
                        this.$refs.tabevent.reloadEventList();
                     }
                  }
               }
            });
         },

         async reloadEventMaster() {
            let response = await this.$http({
               url: "/cca/geteventmaster.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_id: this.edit_group_id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.edit_eventdata = response.data.eventdata;
                  }
               }
            });
         },

         rowClickAdmin(admindata, row) {
            row.select(!row.isSelected);
         },

         async onAdminSaveSelection(admin) {
            this.adminlistdlg = false;
            if (admin && admin.length) {
               await this.$http({
                  url: "/cca/addadmin.php",
                  headers: {
                     "Content-Type": "application/x-www-form-urlencoded",
                  },
                  data: {
                     cca_id: this.edit_group_id,
                     cca_name: this.edit_cca_name,
                     adminlist: admin,
                     userid: this.$globalstore.user.userid,
                     token: this.$globalstore.user.usertoken,
                  },
                  method: "POST",
               }).then((response) => {
                  if (response.data.autherror) {
                     this.$globalstore.user.tokenexpired = true;
                  } else {
                     if (response.data.error) {
                        this.ShowMessage({
                           title: "Error",
                           message: response.data.message,
                           color: "red",
                        });
                     } else {
                        this.reloadAdminList();
                     }
                  }
               });
            }
         },

         async removeAdmin(item) {
            await this.$refs.confirm
               .open("Warning", "Are you sure you want to remove this administrator?", {
                  color: "orange",
               })
               .then((reply) => {
                  if (reply) {
                     this.doRemoveAdmin(item);
                  }
               });
         },

         async doRemoveAdmin(item) {
            let response = await this.$http({
               url: "/cca/removeadmin.php",
               headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
               },
               data: {
                  cca_id: this.edit_group_id,
                  cca_name: this.edit_cca_name,
                  admin_id: item.id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.reloadAdminList();
                  }
               }
            });
         },

         saveWaitListData(data) {
            this.waitlistdata = data;
         },

         saveParticipantData(data) {
            this.participantdata = data;
         },

         saveEventListData(data) {
            this.eventlistdata = data;
         },

         reloadParticipantList() {
            if (this.$refs.tabparticipant) {
               this.$refs.tabparticipant.reloadParticipantList();
            }
         },

         reloadWaitList() {
            if (this.$refs.tabwaitlist) {
               this.$refs.tabwaitlist.reloadWaitList();
            }
         },

         async doReloadParticipantList() {
            let response = await this.$http({
               url: "/cca/getparticipantlist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_id: this.edit_group_id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.participantdata = response.data.participantdata;
                  }
               }
            });
         },

         async loadCategoryList() {
            await this.$http({
               url: "/billing/getccacategory.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  include_disabled: 0,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.categorylist = response.data.ccacategorydata;
                  }
               }
            });
         },

         async LoadScheduleList() {
            await this.$http({
               url: "/cca/getschedulelist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_year: this.edit_cca_year,
                  cca_term: this.edit_cca_term,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.edit_scheduledata = response.data.scheduledata;
                     if (this.schedule_id) {
                        this.edit_schedule = this.edit_scheduledata.find(
                           (x) => x.id == this.schedule_id,
                        );
                     }
                  }
               }
            });
         },

         async reloadAdminList() {
            await this.$http({
               url: "/cca/getadminlist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_id: this.edit_group_id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.edit_admindata = response.data.admindata;
                  }
               }
            });
         },
      },

      async mounted() {
         if (this.$globalstore && this.$globalstore.appready) {
            if (this.$route.params.groupid) {
               this.edit_group_id = this.$route.params.groupid;
               await this.loadCategoryList();
               await this.getGroupByID();
               await this.LoadScheduleList();
            }
         }
      },
   };
</script>

<style>
   tr.v-data-table__selected {
      /* background: #7d92f5 !important; */
      background: #ffcdd2 !important;
   }
</style>
